import { useEffect, useState } from "react";
import api from "../../lib/api";
import { fmtDate } from "../../lib/status";
import { toast } from "sonner";

export default function AdminCoupons() {
    const [coupons, setCoupons] = useState([]);
    const [form, setForm] = useState({
        code: "",
        description: "",
        discount_type: "percentage",
        discount_value: 10,
        min_order: 0,
        max_discount: 100,
        valid_days: 30,
    });
    const load = () => api.get("/coupons").then(({ data }) => setCoupons(data));
    useEffect(() => {
        load();
    }, []);
    const submit = async (e) => {
        e.preventDefault();
        try {
            await api.post("/coupons", form);
            toast.success("Coupon created");
            setForm({ ...form, code: "" });
            load();
        } catch (e) {
            toast.error(e.response?.data?.detail || "Failed");
        }
    };

    return (
        <div className="space-y-6">
            <div>
                <div className="lx-label text-[#D4AF37] mb-2">Promotions</div>
                <h1 className="font-serif text-4xl text-white">Coupons</h1>
            </div>
            <div className="grid lg:grid-cols-3 gap-4">
                <form
                    onSubmit={submit}
                    className="lx-card-dark p-6 space-y-3"
                    data-testid="adm-coupon-form"
                >
                    <div className="lx-label text-[#D4AF37]">New coupon</div>
                    <input
                        required
                        placeholder="CODE"
                        value={form.code}
                        onChange={(e) =>
                            setForm({ ...form, code: e.target.value.toUpperCase() })
                        }
                        data-testid="adm-coupon-code"
                        className="w-full bg-[#180A21] border border-[#2B1438] text-white px-3 py-2"
                    />
                    <input
                        placeholder="Description"
                        value={form.description}
                        onChange={(e) => setForm({ ...form, description: e.target.value })}
                        className="w-full bg-[#180A21] border border-[#2B1438] text-white px-3 py-2"
                    />
                    <select
                        value={form.discount_type}
                        onChange={(e) => setForm({ ...form, discount_type: e.target.value })}
                        className="w-full bg-[#180A21] border border-[#2B1438] text-white px-3 py-2"
                    >
                        <option value="percentage">Percentage</option>
                        <option value="flat">Flat amount</option>
                    </select>
                    <input
                        required
                        type="number"
                        placeholder="Value"
                        value={form.discount_value}
                        onChange={(e) =>
                            setForm({ ...form, discount_value: parseFloat(e.target.value) })
                        }
                        className="w-full bg-[#180A21] border border-[#2B1438] text-white px-3 py-2"
                    />
                    <button
                        type="submit"
                        data-testid="adm-coupon-submit"
                        className="lx-btn-gold w-full py-2.5"
                    >
                        Create
                    </button>
                </form>
                <div className="lg:col-span-2 space-y-2">
                    {coupons.length === 0 && (
                        <div className="lx-card-dark p-10 text-center text-white/60">
                            No coupons.
                        </div>
                    )}
                    {coupons.map((c) => (
                        <div
                            key={c.id}
                            className="lx-card-dark p-5 flex items-center justify-between"
                            data-testid={`adm-coupon-${c.code}`}
                        >
                            <div>
                                <div className="font-serif text-xl text-[#D4AF37]">{c.code}</div>
                                <div className="text-xs text-white/60">{c.description}</div>
                                <div className="text-xs text-white/40 mt-1">
                                    Until {fmtDate(c.valid_until)}
                                </div>
                            </div>
                            <div className="text-right">
                                <div className="font-serif text-xl text-white">
                                    {c.discount_type === "percentage"
                                        ? `${c.discount_value}%`
                                        : `AED ${c.discount_value}`}
                                </div>
                                <div className="text-xs text-white/60">
                                    {c.usage_count}/{c.usage_limit} used
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
